import { fetchStores } from "../api/fetchStores";
import { createMarkers } from "../map/createMarkers";
import { createMarkerClusterer, destroyMarkerClusterer } from "../map/markerClusterer";
import { getSelectedOptions } from "../ui/filters";
import { MarkerClusterer } from "@googlemaps/markerclusterer";

export async function handleForm(
    map: google.maps.Map,
    markers: google.maps.Marker[],
    clusterer: MarkerClusterer | null,
    bounds: google.maps.LatLngBounds,
    selects: Record<string, HTMLSelectElement>
): Promise<MarkerClusterer | null> {
    // Cleaning
    destroyMarkerClusterer(clusterer);
    markers.forEach(m => m.setMap(null));
    markers.length = 0;
    bounds = new google.maps.LatLngBounds();

    // Prepare the filters
    const params: Record<string, any> = {
        region: getSelectedOptions(selects.region),
        product: getSelectedOptions(selects.product),
        type_testimonial: getSelectedOptions(selects.testimonial),
    };

    const locationInput = document.querySelector<HTMLInputElement>('input[name="location"]');
    const coordinatesInput = document.querySelector<HTMLInputElement>('input[name="coordinates"]');

    if (locationInput?.value) params.location = locationInput.value;
    if (coordinatesInput?.value) {
        const [lat, lng] = coordinatesInput.value.split(",");
        params.lat = lat;
        params.lng = lng;
    }

    // 🔹 Récupère les stores
    const stores = await fetchStores(params);
    if (stores.length === 0) {
        console.warn("Aucun résultat trouvé pour ces filtres.");
        return null;
    }

    // 🔹 Retrieve the stores
    createMarkers(map, markers, bounds, stores);

    if (stores.length === 1) {
        map.setCenter(bounds.getCenter());
        map.setZoom(12);
    } else {
        map.fitBounds(bounds);
    }

    const newClusterer = createMarkerClusterer(map, markers);
    return newClusterer;
}
